
import store from '../store'
import { getToken } from '@/utils/auth'
import { getUuid, setUuid } from '@/utils/storage'
import Vue from 'vue'
import router from '../router'
import axios from 'axios'
import global from './global'
import { addOauthPath } from '@/utils/base'
import { httpErrorMessage, mayRetryRequest } from './httpError'

const service = axios.create({




baseURL: `${global.apiUrl}/aa/v1`,
timeout: 15000 
})

service.defaults.retry = 3
service.defaults.retryDelay = 1000


service.interceptors.request.use(request => {


const token = getToken()
if (token) {
request.headers['token'] = token
}
let uuid = getUuid()
if (uuid) {
request.headers['uuid'] = uuid
} else {
uuid = Date.parse(new Date()).toString() + Math.random().toString()
setUuid(uuid)
request.headers['uuid'] = uuid
}
return request
})


service.interceptors.response.use(response => {


return response
}, error => {
store.commit('UPDATE_LOADING_STATUS', { isLoading: false })

if (error.config && error.config.handleErrorLocally) {
return Promise.reject(error)
}
let statusCode = 0
if (error.response) {
statusCode = error.response.status
if (statusCode === 401) {
store.dispatch('FedLogOut')
Vue.$vux.toast.show({
text: '请先登录<br/>(系统自动跳转中)',
type: 'warn',
time: 500,
width: '9em'
})
const path = addOauthPath(router.currentRoute.path,
router.currentRoute.query)
router.push({
path: `/login?back=${encodeURIComponent(path)}`
})
return Promise.reject(error)
} else if (statusCode === 409) {
store.dispatch('FedLogOut')
return Promise.reject(error)
} else {
const content = httpErrorMessage(error)

Vue.$vux.alert.show({
title: '提示',
content: content
})

return Promise.reject(error)
}
} else {
var config = error.config
if (!mayRetryRequest(config)) {
Vue.$vux.alert.show({ title: '提示', content: httpErrorMessage(error) })
return Promise.reject(error)
}

config.__retryCount = config.__retryCount || 0
if (config.__retryCount >= config.retry) {
const content = httpErrorMessage(error)
Vue.$vux.alert.show({
title: '提示',
content: content
})
return Promise.reject(error)
}
config.__retryCount += 1
var backoff = new Promise(function(resolve) {
setTimeout(function() {
resolve()
}, config.retryDelay || 1)
})
return backoff.then(function() {
return service(config)
})
}
})


export default service



// WEBPACK FOOTER //
// ./src/utils/request.js